// houseAliases.js — shared house name matcher (search + layering picker)
// Maps common abbreviations to house names so "YSL" finds Yves Saint Laurent.

const HOUSE_ALIASES = {
  jpg: 'jean paul gaultier',
  ysl: 'yves saint laurent',
  adg: 'acqua di gio',
  tf: 'tom ford',
  pdm: 'parfums de marly',
  mfk: 'maison francis kurkdjian',
  cdg: 'comme des garcons',
  vr: 'viktor rolf',
  ch: 'carolina herrera',
  bdc: 'bleu de chanel',
  cdn: 'creed',
}

/**
 * Checks if a normalized query matches a house name or alias.
 * Returns true if the query is a house abbreviation OR if the house contains the query.
 */
export function queryMatchesHouse(query, house) {
  const q = String(query || '').toLowerCase().trim()
  const h = String(house || '').toLowerCase().trim()
  if (!q || !h) return false

  // Direct match
  if (h.includes(q)) return true

  // Alias expansion — if query is "ysl", expand to "yves saint laurent"
  const expanded = HOUSE_ALIASES[q]
  if (expanded && h.includes(expanded)) return true

  return false
}

/**
 * Expands house abbreviations in a query.
 * Used for display or when the full name is needed.
 */
export function expandHouseAbbrev(query) {
  const q = String(query || '').toLowerCase().trim()
  return HOUSE_ALIASES[q] || query
}
